import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import DemoBlueprints from "../adminPage/blueprint/DemoBlueprints";
import CreateBlueprint from "../adminPage/blueprint/CreateBlueprint";
import EditBlueprint from "../adminPage/blueprint/EditBlueprint";
import {useQuery} from "react-query";
import {userDetails} from "../../../utils/const/query-key";
import apiService from "../../../api/apiService";
import Loading from "../Loading";
import Reports from "../adminPage/reports/Reports";


const PrivateRoute = () => {
    const {data: userData,isLoading} = useQuery(userDetails, () => apiService.getUser(),{ staleTime: Infinity,initialData: {}});

    if (isLoading) {
        return <Loading/>;
    }
    else if(userData?.isAdmin || userData?.isTechPointAdminReports){
        return <Routes>
            <Route path="/blueprints" element={<DemoBlueprints/>}/>
            <Route path="/create-blueprint" element={<CreateBlueprint/>}/>
            <Route path="/edit-blueprint/:blueprint" element={<EditBlueprint/>}/>
            <Route path="/reports" element={<Reports/>}/>
            <Route path="*" element={<Navigate replace to={"/admin/blueprints"} />} />
        </Routes>
    }
    else{
        return <Routes>
            <Route path="*" element={<Navigate replace to={"/demo-point"} />} />
        </Routes>
    }

}


export default PrivateRoute;
